/*
apiClient.js
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import axios from "axios";
import { getSessionVar } from "../browserStorage";
import { sessionVar } from "../../constants/storage.const";

const axiosInstanceConfig = {
    baseURL: import.meta.env.VITE_APP_API_URL
};

const interceptorHeaders = [
    { header: "x-api-key", sessionKey: sessionVar.apiKey }
];

const requestInterceptor = config => {
    interceptorHeaders.forEach(h => {
        if (h) {
            config.headers[h.header] = getSessionVar(h.sessionKey);
        }
    });
    return config;
};

const responseErrorHandler = error => {
    if (error.code === "ERR_NETWORK") {
        return Promise.reject({ ...error, code: "FM_007" });
    }
    return Promise.reject(error);
};

const axiosInstance = axios.create(axiosInstanceConfig);
axiosInstance.interceptors.request.use(requestInterceptor);
axiosInstance.interceptors.response.use(
    response => response,
    responseErrorHandler
);

export { axiosInstance };